import { render, staticRenderFns } from "./Prospect_Details.vue?vue&type=template&id=213a5572&"
import script from "./Prospect_Details.vue?vue&type=script&lang=js&"
export * from "./Prospect_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports